<template>
  <div class="pt-5 animate__animated animate__fadeIn">
    <b-row class="pt-5">
      <b-col cols="12" lg="8" offset-xl="1" xl="7">
        <b-row class="no-gutters">
          <b-col
            cols="10"
            offset="1"
            class="d-flex align-items-center justify-content-center "
          >
            <!-- start: mobile -->
            <p class="text-primary font-weight-bold d-md-none title-mobile">
              Arborescence de la délibération
            </p>
            <!-- end: mobile -->
            <div
              class="box-title text-primary font-weight-bold  d-none d-md-block"
            >
              {{ arborescence.data.title }}
            </div>
          </b-col>
          <b-col cols="12 text-center">
            <div class="d-none d-md-block">
              <img
                src="@/assets/img/u5457_seg5.png"
                class="d-inline-block align-center"
              />
            </div>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="px-1 mb-5"
            :class="typeComment[n].border"
            v-for="n in 3"
            :key="n"
          >
            <div>
              <div class="text-center d-none d-md-block">
                <img
                  src="@/assets/img/u5457_seg0.png"
                  class="d-inline-block align-center"
                />
              </div>
              <b-row>
                <b-col>
                  <div
                    class="box-item text-white d-none d-md-block"
                    :class="`bg-${typeMap[n].variant}`"
                  >
                    {{ typeMap[n].text }} ({{
                      arborescence.data[typeComment[n].text].total
                    }})
                  </div>
                  <!-- start: mobile -->
                  <b-button
                    :variant="typeMap[n].variant"
                    pill
                    block
                    class="d-md-none p-3"
                    v-b-toggle="`collapse-${n}`"
                  >
                    {{ typeMap[n].text }} ({{
                      arborescence.data[typeComment[n].text].total
                    }})
                    <div class="float-right">
                      <b-iconstack font-scale="1.2" class="mr-2">
                        <b-icon
                          stacked
                          icon="chat-fill"
                          variant="white"
                        ></b-icon>
                        <b-icon
                          stacked
                          icon="chat"
                          variant="white"
                          shift-h="3"
                          shift-v="-1"
                          flip-h
                        ></b-icon>
                      </b-iconstack>
                      <span class="mr-2">
                        {{
                          arborescence.data[typeComment[n].text]
                            .total_discussions
                        }}
                      </span>
                    </div>
                  </b-button>
                  <!-- end: mobile -->
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-collapse
                    :id="`collapse-${n}`"
                    class="dont-collapse"
                    :visible="n == 1"
                  >
                    <div class="border-left-branches">
                      <b-row
                        class="no-gutters pt-4"
                        v-for="d in arborescence.data[typeComment[n].text]
                          .discussions"
                        :key="d.id"
                      >
                        <b-col
                          cols="12"
                          class="d-flex-desktop align-items-center justify-content-left"
                        >
                          <img
                            src="@/assets/img/u5442_seg1.png"
                            class="connector d-inline-block margin-icon-branch"
                          />
                          <b-iconstack
                            font-scale="1.5"
                            :id="`popover-target-${n}-${d.id}`"
                            class="mr-2 ml-1 change-color-icon animate__animated"
                            :class="{ 'color-icon-primary': isDiscussion(d) }"
                          >
                            <b-icon
                              stacked
                              icon="chat-fill"
                              variant="secondary"
                            ></b-icon>
                            <b-icon
                              v-if="isDiscussion(d)"
                              stacked
                              icon="chat"
                              variant="secondary"
                              shift-h="3"
                              shift-v="-1"
                              flip-h
                            ></b-icon>
                          </b-iconstack>
                          <!-- start: mobile -->
                          <div class="py-2 pr-3 d-md-none comment">
                            <span
                              class="font-weight-bolder text-primary d-block"
                              >{{ d.user.nickname }}
                            </span>
                            <small class="text-muted"
                              >{{ d.created_at | formatDateTime }}
                            </small>
                            <p>
                              <span
                                :class="`text-${typeMap[d.type].variant}`"
                                >{{ typeMap[d.type].text }}</span
                              >
                              {{ d.comment }}
                            </p>
                          </div>
                          <!-- end: mobile -->
                          <b-popover
                            :target="`popover-target-${n}-${d.id}`"
                            triggers="hover"
                            placement="right"
                          >
                            <div class="p-2">
                              <b-iconstack
                                font-scale="1.8"
                                class="msg-type-icon"
                              >
                                <b-icon
                                  stacked
                                  icon="chat-fill"
                                  variant="primary"
                                ></b-icon>
                                <b-icon
                                  stacked
                                  icon="chat"
                                  variant="primary"
                                  shift-h="3"
                                  shift-v="-1"
                                  flip-h
                                ></b-icon>
                              </b-iconstack>
                              <span
                                class="font-weight-bolder text-primary d-block pt-2"
                                >{{ d.user.nickname }}
                              </span>
                              <small class="text-muted"
                                >{{ d.created_at | formatDateTime }}
                              </small>
                              <p>
                                <span
                                  :class="`text-${typeMap[d.type].variant}`"
                                  >{{ typeMap[d.type].text }}</span
                                >
                                {{ d.comment }}
                              </p>
                              <hr class="mb-2" />
                              <b-button
                                variant="link"
                                class="text-info ml-2"
                                @click="moveToAnswers(d.id)"
                                :disabled="!isDiscussion(d)"
                                >Voir la discussion</b-button
                              >
                            </div>
                          </b-popover>
                          <div class="d-flex discussions">
                            <div
                              class="mr-1 box-item-child bg-success text-white"
                            >
                              ({{ d.positive_answers_count }})
                            </div>
                            <div
                              class="mr-1 box-item-child bg-danger text-white"
                            >
                              ({{ d.negative_answers_count }})
                            </div>
                            <div class="box-item-child bg-purple text-white">
                              ({{ d.neutral_answers_count }})
                            </div>
                          </div>
                          <!-- start: mobile -->
                          <div>
                            <b-button
                              variant="link"
                              class="text-info discussions mt-2 d-md-none"
                              @click="moveToAnswers(d.id)"
                              :disabled="!isDiscussion(d)"
                              >Voir la discussion</b-button
                            >
                          </div>
                          <!-- end: mobile -->
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="isEvaluation">
          <b-col class="px-5 animate__animated animate__fadeIn">
            <!-- content header -->
            <StudentContentBody
              v-bind:deliberation="dlibr.id"
              v-bind:groupId="dlibr.group"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" xl="3" lg="4">
        <div>
          <b-card bg-variant="light" v-if="!isEvaluation">
            <span class="text-primary font-weight-bold pl-2">
              Participants
            </span>

            <b-table-simple small bordered>
              <b-thead>
                <b-tr>
                  <b-th><span class="sr-only">participants</span></b-th>
                  <b-th class="text-center"
                    ><b-icon
                      icon="chat-fill"
                      variant="secondary"
                      scale="1.2"
                      v-b-tooltip.hover
                      title="total des publications"
                    ></b-icon
                  ></b-th>
                  <b-th class="text-center" :class="modeEval">
                    <font-awesome-icon
                      :icon="['fas', 'percent']"
                      class="text-secondary"
                    />
                  </b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-td
                    :colspan="modeEval ? 3 : 2"
                    v-if="
                      !Boolean(
                        arborescence.data.participants.find(p => p).length
                      )
                    "
                  >
                    Aucun participant à cette délibération
                  </b-td>
                </b-tr>
                <b-tr
                  v-for="item in arborescence.data.participants.find(p => p)"
                  :key="item.id"
                >
                  <b-td class="align-middle py-2 pl-2">
                    {{ item.name }} {{ item.last_name }}
                  </b-td>
                  <b-td class="text-center align-middle">{{
                    item.total_comments
                  }}</b-td>
                  <b-td class="text-center align-middle" :class="modeEval">
                    <b-button
                      variant="none"
                      toggle-class="text-decoration-none"
                      size="sm"
                      pill
                      :disabled="allBtnDisabled"
                      @click="
                        onTotalGrades({ user: item.id, group: dlibr.group })
                      "
                    >
                      <font-awesome-icon
                        :icon="['fas', 'arrow-right']"
                        class="text-secondary"
                        v-if="!buttonsLoading[item.id]"
                      />
                      <b-spinner
                        class="text-secondary"
                        small
                        v-if="buttonsLoading[item.id]"
                      />
                    </b-button>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card>
          <b-card
            bg-variant="light"
            v-if="isEvaluation && this.flowDlibr.evalMode"
            class="animate__animated animate__fadeInRight animate__faster"
          >
            <div class="d-flex justify-content-between mb-4">
              <h5 class="font-weight-bold">
                {{ user.name }} {{ user.last_name }}
              </h5>
              <b-button
                variant="primary"
                pill
                @click="isEvaluation = !isEvaluation"
              >
                Fermer
              </b-button>
            </div>
            <!-- Critères de correction -->
            <StudentCorrection
              v-bind:deliberation="dlibr.id"
              v-bind:groupId="dlibr.group"
            />
            <hr />
            <!-- Analytique -->
            <StudentAnalytics
              v-bind:deliberation="dlibr.id"
              v-bind:groupId="dlibr.group"
            />
          </b-card>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
/**
 * @file       Deliberation arboresence graph component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import Vue from "vue";
import store from "@/store";
import { mapState } from "vuex";
import { commentsMixin } from "@/modules/comments/mixins";
import StudentCorrection from "@/modules/admin/components/students/correction.vue";
import StudentAnalytics from "@/modules/admin/components/students/analytics.vue";
import StudentContentBody from "@/modules/admin/components/students/contentBody.vue";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "arborescenceGraph",
  mixins: [commentsMixin],
  components: {
    StudentCorrection,
    StudentAnalytics,
    StudentContentBody
  },

  /**
   * Before route change.
   * 
   * @param  {string}   to     Destination
   * @param  {string}   from   (Unused)
   * @param  {Object}   next   The action
   */
  beforeRouteEnter(to, from, next) {
    store
      .dispatch("deliberations/getDlibr", {
        params: { teacher: to.params.teacher, url: to.params.url }
      })
      .then(({ data }) => {
        store
          .dispatch("deliberations/getArborescenceDlibr", {
            params: { deliberation: data.data.find(d => d).id }
          })
          .then(() => next());
      })
      .catch(() => {
        next(vm => {
          vm.$root.$bvToast.toast(
            "Aucune délibération trouvée pour cette URL",
            {
              title: "Erreur",
              variant: "danger"
            }
          );
          vm.$router.push({ name: "home" });
        });
      });
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      arborescence: state => state.deliberations.arborescenceDlibr.data,
      user: state => state.admin.user.data
    }),

    /**
     * Type comment.
     * 
     * @return   {Array}   Text and border specifications
     */
    typeComment() {
      return {
        1: { text: "positive_comments", border: "half-a-border-on-top-left" },
        2: { text: "negative_comments", border: "border-on-top-center" },
        3: { text: "neutral_comments", border: "half-a-border-on-top-right" }
      };
    },

    /**
     * Eval mode CSS class.
     * 
     * @return   {String}   CSS class
     */
    modeEval() {
      return this.flowDlibr.evalMode ? "d-block" : "d-none";
    }
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Check the discussion count.
     *
     * @param     {Object}   d   The discussion
     *
     * @return    {bool}     true or false.
     */
    isDiscussion(d) {
      return (
        Boolean(d.positive_answers_count) ||
        Boolean(d.negative_answers_count) ||
        Boolean(d.neutral_answers_count)
      );
    },

    /**
     * Total grades.
     *
     * @param     {Object}   params   The parameters
     */
    onTotalGrades(params) {
      this.userId = params.user;
      this.allBtnDisabled = true;
      Vue.set(this.buttonsLoading, params.user, true);
      store.dispatch("admin/getUserByID", params.user).then(() => {
        store.commit("admin/setTotalGradesFilters", {
          reset: true,
          fields: {
            user: params.user,
            group: params.group
          }
        });
        store
          .dispatch("admin/getTotalGrades")
          .then(() => {
            this.isEvaluation = !this.isEvaluation;
            Vue.set(this.buttonsLoading, params.user, false);
            this.allBtnDisabled = false;
          })
          .catch(() => {
            Vue.set(this.buttonsLoading, params.user, false);
            this.allBtnDisabled = false;
          });
      });
    }
  },

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      isEvaluation: false,
      userId: null,
      buttonsLoading: [],
      allBtnDisabled: false
    };
  },
  watch: {
    modeEval: {
      handler: function(val) {
        if (val == "d-none") {
          this.isEvaluation = false;
          this.allBtnDisabled = false;
        }
      },
      deep: true
    }
  },
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style lang="scss" scoped>
/deep/ table thead {
  border-top: solid 2px transparent !important;
  border-left: solid 2px transparent !important;
  border-right: solid 2px transparent !important;
}
.table thead tr th {
  border: none;
}
.title-mobile {
  margin-top: -2rem;
  margin-bottom: 2rem;
}

.border-left-branches {
  margin-top: -0.1rem;
  margin-left: 1rem;
  border-left: 2px solid #cccccc !important;
}

.connector {
  margin-left: -0.2rem;
}

.margin-icon-branch {
  margin-left: -5px !important;
}

.popover.b-popover {
  border-radius: 20px !important;
  .msg-type-icon {
    position: absolute;
    top: -0.8rem;
  }
}

.box-title {
  background-color: #f2f2f2;
  padding: 1rem 5rem;
  border-radius: 50rem;
  text-align: center;
  vertical-align: middle;
}

.box-item {
  background-color: #f2f2f2;
  padding: 1rem;
  border-radius: 50rem;
  font-weight: 900 !important;
  text-align: center;
  vertical-align: middle;
}

.box-item-child {
  background-color: #f2f2f2;
  padding: 0.5rem 1rem;
  border-radius: 50rem;
  font-weight: 900 !important;
  font-size: 0.8rem;
  text-align: center;
  vertical-align: middle;
  min-width: 3.2rem;
}

.card {
  border-radius: 20px !important;
}

@media (max-width: 768px) {
  .comment {
    margin-left: 3.5rem;
    margin-top: -2rem;
  }
  .discussions {
    margin-left: 3.5rem;
    margin-top: -1rem;
  }
  .color-icon-primary {
    svg {
      color: #323463 !important;
    }
  }
}

@media (min-width: 768px) {
  div.half-a-border-on-top-left {
    border-top: 2px solid #cccccc;
    position: relative;
    &:after {
      padding: 0;
      margin: 0;
      display: block;
      content: "";
      width: 50%;
      height: 2px;
      background-color: white;
      position: absolute;
      left: 0;
      top: -2px;
    }
  }
  .border-on-top-center {
    border-top: 2px solid #cccccc;
  }
  .half-a-border-on-top-right {
    border-top: 2px solid #cccccc;
    position: relative;
    &:after {
      padding: 0;
      margin: 0;
      display: block;
      content: "";
      width: 50%;
      height: 2px;
      background-color: white;
      position: absolute;
      right: 0;
      top: -2px;
    }
  }
  .dont-collapse {
    display: block !important;
  }
  .change-color-icon:hover {
    svg {
      color: #323463 !important;
    }
    &:hover {
      animation-name: jello;
    }
  }
  .d-flex-desktop {
    display: flex !important;
  }
}
</style>
